import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';
import { SalaryCalculationsComponent } from './salary-calculations/salary-calculations.component';
import { EmployeeAddComponent } from './employee-payroll-managment/employee-add/employee-add.component';
import { LoanRequestComponent } from './employee-payroll-managment/loan-request/loan-request.component';
import { AttendanceManagementComponent } from './attendance-management/attendance-management.component';
import { UserAttendanceListComponent } from './attendance-management/user-attendance-list/user-attendance-list.component';
import { LoanDetailComponent } from './employee-payroll-managment/loan-detail/loan-detail.component';
import { UserAttendanceRequestsComponent } from './attendance/user-attendance-requests/user-attendance-requests.component';
import { EventManagementComponent } from './event-management/event-management.component';
import { CreateEventComponent } from './event-management/create-event/create-event.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { EvaluationYearlyComponent } from './evaluation/evaluation-yearly/evaluation-yearly.component';
import { UserEvaluationComponent } from './evaluation/user-evaluation/user-evaluation.component';
import { AddEvaluationComponent } from './evaluation/add-evaluation/add-evaluation.component';
import { AccountManagmentComponent } from './account-managment/account-managment.component';
import { UpdateEvaluationComponent } from './evaluation/update-evaluation/update-evaluation.component';
import { AdminAccountsComponent } from './account-managment/admin-accounts/admin-accounts.component';
import { EvaluationListComponent } from './evaluation/evaluation-list/evaluation-list.component';
import { SettingsComponent } from './settings/settings.component';
import { PolicyComponent } from './settings/policy/policy.component';
import { AddPolicyComponent } from './settings/add-policy/add-policy.component';
import { AllUserEvaluationComponent } from './all-user-evaluation/all-user-evaluation.component';
import { SetupTextAutomationComponent } from './settings/setup-text-automation/setup-text-automation.component';
import { Dashboard1Component } from './component-theme1/dashboard-1/dashboard-1.component';
import { NewAdminDashboardComponent } from './component-theme1/admin-dashboad/new-admin-dashboard/new-admin-dashboard.component';
import { UserRolesComponent } from './settings/user-roles/user-roles.component';
import { UserRolesViewComponent } from './settings/user-roles-view/user-roles-view.component';
import { UserLeavesComponent } from './component-theme1/user-leaves/user-leaves.component';
import { UserLeavesViewComponent } from './component-theme1/user-leaves-view/user-leaves-view.component';
import { UserAttendanceComponent } from './component-theme1/user-attendance/user-attendance.component';
import { UserAttendanceViewComponent } from './component-theme1/user-attendance-view/user-attendance-view.component';
import { NotificationsComponent } from './component-theme1/notifications/notifications.component';
import { AnnouncementsComponent } from './component-theme1/announcements/announcements.component';
import { AnnouncementMainComponent } from 'src/app/announcement-management/announcement-main/announcement-main.component';
import { AddAnnouncementComponent } from './announcement-management/add-announcement/add-announcement.component';
import { TeamManagementComponent } from './component-theme1/team-management/team-management.component';
import { UserViewComponent } from './component-theme1/user-view/user-view.component';
import { NewLoginComponent } from './auth/components/new-login/new-login.component';
import { MainComponent } from 'src/app/evaluation/main/main.component';
import { EvaluationSummaryComponent } from 'src/app/evaluation/evaluation-summary/evaluation-summary.component';
import { MainComponentLeave } from 'src/app/leaves/main/main.component';
import { ApplyLeavesComponent } from 'src/app/leaves/apply-leaves/apply-leaves.component';
import { LeavesStatusComponent } from 'src/app/leaves/leaves-status/leaves-status.component';
import { MainComponentAttendance } from 'src/app/attendance/main/main.component';
import { AttendanceCorrectionRequestComponent } from 'src/app/attendance/attendance-correction-request/attendance-correction-request.component';
import { MainComponentCompanyPolicy } from 'src/app/company-policy/main/main.component';
import { EmployeePayrollManagmentComponent } from 'src/app/employee-payroll-managment/main/employee-payroll-managment.component';
import { EmployeeMonthlySalaryComponent } from 'src/app/employee-payroll-managment/employee-monthly-salary/employee-monthly-salary.component';
import { EmployeePayrollSalaryDetailComponent } from 'src/app/employee-payroll-managment/employee-payroll-salary-detail/employee-payroll-salary-detail.component';
import { LoanReportComponent } from 'src/app/employee-payroll-managment/loan-report/loan-report.component';
import { TeamLeadViewComponent } from 'src/app/employee-payroll-managment/team-lead-view/team-lead-view.component';
import { ShowLeavesComponent } from 'src/app/leaves-management/show-leaves/show-leaves.component';
import { LeaveReportComponent } from 'src/app/leaves-management/leave-report/leave-report.component';
import { MainComponentNotes } from 'src/app/notes/main/main.component';
import { MainComponentPayroll } from 'src/app/payroll/main/main.component';
import { PaySlipComponent } from 'src/app/payroll/pay-slip/pay-slip.component';
import { ResignationApplyComponent } from 'src/app/resignation/resignation-apply/resignation-apply.component';
import { ResignationListComponent } from './resignation/resignation-list/resignation-list.component';
import { AddNewsUpdatesComponent } from 'src/app/shared/components/add-news-updates/add-news-updates.component';
import { NewsUpdatesListComponent } from 'src/app/shared/components/news-updates-list/news-updates-list.component';
import { HolidayComponent } from 'src/app/shared/components/holiday/holiday.component';
import { HolidayFormComponent } from 'src/app/shared/components/holiday/holiday-form/holiday-form.component';
import { UpdatePasswordComponent } from 'src/app/updatePassword/main/update-password.component';
import { EmployeePayrollsDetailComponent } from './employee-payroll-managment/employee-payrolls-detail/employee-payrolls-detail.component';
import { PayrollMainComponent } from './component-theme1/pay-roll-managment/payroll-main/payroll-main.component';
import { PayrollListComponent } from './component-theme1/pay-roll-managment/payroll-list/payroll-list.component';
import { PayrollSheetComponent } from './component-theme1/pay-roll-managment/payroll-sheet/payroll-sheet.component';
import { PayrollSummaryComponent } from './component-theme1/payroll-admin-management/payroll-summary/payroll-summary.component';
import { NewPayrollComponent } from './component-theme1/payroll-admin-management/new-payroll/new-payroll.component';
import { PreviewPayrolComponent } from './component-theme1/payroll-admin-management/preview-payrol/preview-payrol.component';
import { PastPayrollComponent } from './component-theme1/payroll-admin-management/past-payroll/past-payroll.component';
import { Setting2Component } from './new-settings/setting2.component';
import { ManualAddPayrollComponent } from './component-theme1/payroll-admin-management/manual-add-payroll/manual-add-payroll.component';
import { EmployeesSalaryInfoComponent } from './component-theme1/payroll-admin-management/employees-salary-info/employees-salary-info.component';
import { AttendanceReportsComponent } from './pages/attendance-reports/attendance-reports.component';
import { AttendanceRequestComponent } from './component-theme1/user-attendance/attendance-request/attendance-request.component';
import { BulkAttendanceEditComponent } from './bulk-attendance-edit/bulk-attendance-edit.component';



export const routes: Routes = [
  { path: '', component: NewLoginComponent },

  // { path: 'new-settings', component: Setting2Component },
  // { path: 'setting2', component: Setting2Component },
  { path: 'salary-calculations', component: SalaryCalculationsComponent },
  { path: 'employee-add/:uuid', component: EmployeeAddComponent },
  { path: 'loan-request', component: LoanRequestComponent },
  { path: 'user-attendance-list', component: UserAttendanceListComponent },
  { path: 'attendance-reports', component: AttendanceReportsComponent },
  { path: 'attendance-management', component: AttendanceManagementComponent },
  { path: 'loan-detail', component: LoanDetailComponent },
  { path: 'user-attendance-requests/:id', component: UserAttendanceRequestsComponent },
  { path: 'event-management', component: EventManagementComponent },
  { path: 'create-event', component: CreateEventComponent },
  { path: 'create-event/:id', component: CreateEventComponent },
  { path: 'admin-dashboard', component: AdminDashboardComponent },  //extra page
  { path: 'evaluation-yearly', component: EvaluationYearlyComponent },
  { path: 'user-evaluation', component: UserEvaluationComponent },
  { path: 'accounts-managment', component: AccountManagmentComponent },
  { path: 'update-evaluation', component: UpdateEvaluationComponent },
  { path: 'add-evaluation', component: AddEvaluationComponent },
  { path: 'admin-accounts', component: AdminAccountsComponent },
  { path: 'evaluation-list', component: EvaluationListComponent },
  { path: 'evaluation-user', component: UserEvaluationComponent },
  { path: 'new-settings', component: Setting2Component },
  { path: 'policy', component: PolicyComponent },
  { path: 'add-policy', component: AddPolicyComponent },
  { path: 'add-policy/:uuid', component: AddPolicyComponent },
  { path: 'all-users-evaluation', component: AllUserEvaluationComponent },
  { path: 'setup-text-automation', component: SetupTextAutomationComponent },


  //theme-1 routes
  { path: 'dashboard-1', component: Dashboard1Component },
  { path: 'new-admin-dashboard', component: NewAdminDashboardComponent },
  // { path: 'new-admin-dashboard', component: NewAdminDashboardComponent },
  { path: 'user-role', component: UserRolesComponent },
  { path: 'user-role-view', component: UserRolesViewComponent },
  { path: 'user-leaves', component: UserLeavesComponent },
  { path: 'user-leaves/:paidLeaves/:rejectedLeaves', component: UserLeavesComponent },
  { path: 'user-leaves-view', component: UserLeavesViewComponent },
  { path: 'user-attendance', component: UserAttendanceComponent },
  { path: 'user-attendance-view/:id', component: UserAttendanceViewComponent },
  { path: 'notifications', component: NotificationsComponent },
  { path: 'announcement', component: AnnouncementsComponent },
  { path: 'announcements', component: AnnouncementMainComponent },
  { path: 'add-announcement', component: AddAnnouncementComponent },
  { path: 'team-management', component: TeamManagementComponent },
  { path: 'add-announcement/:id', component: AddAnnouncementComponent },
  { path: 'user-profile-view/:user_uuid', component: UserViewComponent },

  { path: 'evaluation', component: MainComponent },
  { path: 'evaluation-summary', component: EvaluationSummaryComponent },
  { path: 'evaluation-add', component: AddEvaluationComponent },

  { path: 'leaves', component: MainComponentLeave },
  { path: 'apply-leaves/:paidLeaves/:rejectedLeaves', component: ApplyLeavesComponent },
  { path: 'leaves-status', component: LeavesStatusComponent },

  { path: 'attendance', component: MainComponentAttendance },
  { path: 'attendance-correction-request', component: AttendanceCorrectionRequestComponent },
  { path: 'company-policy', component: MainComponentCompanyPolicy },
  { path: 'employee-payroll-managment', component: EmployeePayrollManagmentComponent },
  { path: 'employee-payrolls-detail', component: EmployeePayrollsDetailComponent },
  { path: 'employee-payroll-salary-detail', component: EmployeePayrollSalaryDetailComponent },
  { path: 'employee-monthly-salary', component: EmployeeMonthlySalaryComponent },
  { path: 'employee-add', component: EmployeeAddComponent },
  { path: 'loan-report', component: LoanReportComponent },
  { path: 'team-lead-view', component: TeamLeadViewComponent },
  { path: 'show-leaves', component: ShowLeavesComponent },
  { path: 'leave-report', component: LeaveReportComponent },
  { path: 'notes', component: MainComponentNotes },
  { path: 'payroll', component: MainComponentPayroll },
  { path: 'pay_slip', component: PaySlipComponent },
  { path: 'apply-resignation', component: ResignationApplyComponent },
  { path: 'resignation-list', component: ResignationListComponent },
  { path: 'add-news-updates', component: AddNewsUpdatesComponent },
  { path: 'news-update-gallery', component: NewsUpdatesListComponent },
  { path: 'holiday', component: HolidayComponent },
  { path: 'holiday-form', component: HolidayFormComponent },
  { path: 'update-password', component: UpdatePasswordComponent },
  { path: 'payroll-main', component: PayrollMainComponent },
  { path: 'payroll-list', component: PayrollListComponent },
  { path: 'payroll-sheet', component: PayrollSheetComponent },
  { path: 'payroll-summary', component: PayrollSummaryComponent },
  { path: 'add-new-payroll', component: NewPayrollComponent },
  { path: 'preview-payroll', component: PreviewPayrolComponent },
  { path: 'past-payroll', component: PastPayrollComponent },
  { path: 'manual-payroll', component: ManualAddPayrollComponent },
  { path: 'employee-salary-info', component: EmployeesSalaryInfoComponent },
  { path: 'setting', component: SettingsComponent },
  { path: 'attendance-requests', component: AttendanceRequestComponent },
  { path: 'bulk-attendance-edit', component: BulkAttendanceEditComponent },








  { path: '**', redirectTo: '' } // fallback

];